/* Markup inline <color:#red>…</color> — porting da flusso-urgenze.html (700-712).
   `plain`/`firstLine` sono indipendenti dal tema (servono a prepare/layout e
   alla ricerca); `parseRuns` risolve i colori per tema e serve al renderer. */

export interface Run {
  text: string;
  color: string | null;
}

const TAG = /<color:[^>]+>|<\/color>/g;

/** Testo senza i tag di colore. */
export function plain(text: string): string {
  return text.replace(TAG, "");
}

/** Prima riga del testo, senza markup, trimmata. */
export function firstLine(text: string): string {
  return plain(text).split("\n")[0]!.trim();
}

/** Divide il testo in run colorati. Un tag non chiuso colora fino a fine stringa.
    `colorMap` mappa i nomi (red/green/…) ai colori del tema attivo. */
export function parseRuns(text: string, colorMap: Record<string, string>): Run[] {
  const runs: Run[] = [];
  let cur: string | null = null;
  const re = /<color:([^>]+)>|<\/color>/g;
  let m: RegExpExecArray | null;
  let last = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) runs.push({ text: text.slice(last, m.index), color: cur });
    cur = m[0] === "</color>" ? null : colorMap[m[1]!.replace("#", "")] ?? m[1]!;
    last = re.lastIndex;
  }
  if (last < text.length) runs.push({ text: text.slice(last), color: cur });
  return runs.length ? runs : [{ text: "", color: null }];
}

/** Divide una lista di run in righe (spezzando ai \n), preservando i colori. */
export function splitRunsByLine(runs: Run[]): Run[][] {
  const lines: Run[][] = [[]];
  for (const r of runs) {
    const parts = r.text.split("\n");
    parts.forEach((p, i) => {
      if (i > 0) lines.push([]);
      if (p) lines[lines.length - 1]!.push({ text: p, color: r.color });
    });
  }
  return lines;
}
